import axios from 'axios'

const GET = 'get'
const POST = 'post'
const PUT = 'put'

const instance = axios.create({
  timeout: 60000,
  headers: {
    'Cache-Control': 'no-cache',
    Expires: '-1',
    Pragma: 'no-cache'
  }
})

export const dpprApi = async ({ url, method, data, ...rest }) => await instance[method](url, data, rest) // NOSONAR
export const dpprApiGet = async (options) => await dpprApi({ method: GET, ...options })
export const dpprApiPost = async (options) => await dpprApi({ method: POST, ...options })
export const dpprApiPut = async (options) => await dpprApi({ method: PUT, ...options })

export const syncDpprApi = ({ url, method, data }) => {
  const client = new XMLHttpRequest()
  client.open(method, url, false)
  client.setRequestHeader('Content-Type', 'application/json;charset=UTF-8')
  client.send(JSON.stringify(data))
  return client
}
export const snycDpprApiPost = (options) => syncDpprApi({ method: POST, ...options })
